module.exports = __webpack_public_path__ + "static/media/GIII_NHL_Logo_FR.534e0514.svg";